<template>
	<div class="app">
		<AppHeader fixed>
			<SidebarToggler class="d-lg-none" display="md" mobile/>
			<b-link class="navbar-brand" to="#">
				<!-- <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
				<img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">-->
				<img class="navbar-brand-full" src="img/logo.png" width="76" height="30" alt="app-logo">
				<img class="navbar-brand-minimized" src="img/logo.png" width="30" height="30" alt="app-logo">
			</b-link>
			<SidebarToggler class="d-md-down-none" display="lg"/>
			<!-- <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
			</b-navbar-nav>-->
			<b-navbar-nav class="ml-auto">
				<!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
				</b-nav-item>-->
				<b-nav-item class="d-md-down-none">{{ $store.getters.usuario.nome }}</b-nav-item>
				<DefaultHeaderDropdownAccnt/>
				<b-nav-item class="d-md-down-none">
					<app-tempo-sessao></app-tempo-sessao>
				</b-nav-item>
				<b-nav-item>
					<i class="fa fa-sign-out fa-lg" @click.stop="$store.dispatch('logout')" title="Sair"></i>
				</b-nav-item>
			</b-navbar-nav>
			<!-- <AsideToggler class="d-none d-lg-block" /> -->
			<!--<AsideToggler class="d-lg-none" mobile />-->
		</AppHeader>
		<div class="app-body">
			<AppSidebar fixed>
				<SidebarHeader/>
				<SidebarForm/>
				<SidebarNav :navItems="navMenu"></SidebarNav>
				<SidebarFooter/>
				<SidebarMinimizer/>
			</AppSidebar>
			<main class="main pt-4">
				<!-- <Breadcrumb :list="list"/> -->
				<div class="container-fluid">
					<router-view></router-view>
				</div>
			</main>
			<AppAside fixed>
				<!--aside-->
				<!-- <DefaultAside/> -->
			</AppAside>
		</div>
		<TheFooter>
			<!--footer-->
			<span class="mr-auto">
				<span class="ml-1">&copy; {{ new Date().getFullYear() }} SEBRAE</span>
			</span>
			<span class="mx-auto">
				<strong>v{{ versao }}</strong>
			</span>
			<span class="ml-auto">
				<span class="mr-1">Powered by</span>
				<a href="https://www.linkedin.com/in/emerson-paz-7100863b/">Blue</a>
			</span>
			<!-- <div>
        <a href="/">APP</a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }} PazNet</span>
      </div>
      <div class="mx-auto">
        <span>
          <strong>v{{ versao }}</strong>
        </span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://www.linkedin.com/in/emerson-paz-7100863b/">PazNet</a>
			</div>-->
		</TheFooter>
	</div>
</template>

<script>
import {
	Header as AppHeader,
	SidebarToggler,
	Sidebar as AppSidebar,
	SidebarFooter,
	SidebarForm,
	SidebarHeader,
	SidebarMinimizer,
	SidebarNav,
	Aside as AppAside,
	AsideToggler,
	Footer as TheFooter,
	Breadcrumb
} from '@coreui/vue'
// import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
	name: 'DefaultContainer',
	components: {
		AsideToggler,
		AppHeader,
		AppSidebar,
		AppAside,
		TheFooter,
		Breadcrumb,
		// DefaultAside,
		DefaultHeaderDropdownAccnt,
		SidebarForm,
		SidebarFooter,
		SidebarToggler,
		SidebarHeader,
		SidebarNav,
		SidebarMinimizer
	},
	data() {
		return {
			versao: process.env.VUE_APP_VERSION
		}
	},
	computed: {
		name() {
			return this.$route.name
		},
		list() {
			return this.$route.matched.filter(
				route => route.name || route.meta.label
			)
		},
		navMenu() {
			return this.$store.getters.menu
		}
	}
}
</script>
